<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                 
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'المستخدمين'" :to="{name: 'admins'}">المستخدمين</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'إضافة جديد'" :to="{name: 'admins.create'}">إضافة جديد</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                

                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">                                
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                                <i class="flaticon-computer-4"></i> 
                                            بيانات المستخدم</h4>
                                    </div>
                                </div> 
                            </div>
                            <div class="widget-content widget-content-area">
                               
                                <form @submit.prevent="store()">
                                     <div class="row">
                                         <div class="col-md-6">
                                              <label for="exampleFormControlInput12">الاسم</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>  
                                       
                                        <input type="text" class="form-control" id="exampleFormControlInput12" v-model="data.form.name" placeholder="الاسم كامل">
                                        <div class="invalid-feedback" :style="getErrors['name'] ? 'display: block' : 'display: none;'"  v-if="getErrors['name']">
                                              {{ getErrors['name'][0] }}
                                        </div>
                                    </div>
                                       </div>
                            
                                    <div class="col-md-6">
                                                <label for="exampleFormControlInput1">البريد الإلكتروني</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-email"></i></span>
                                      </div>
                                 
                                        <input type="email" class="form-control" id="exampleFormControlInput1" v-model="data.form.email" placeholder="name@example.com">
                                        <div class="invalid-feedback" :style="getErrors['email'] ? 'display: block' : 'display: none;'"   v-if="getErrors['email']">
                                              {{ getErrors['email'][0] }}
                                        </div>
                                    </div>
                                       </div> 
                                  
                                   <div class="col-md-6">
                                                                         
                                        <label for="exampleFormControlInput3">كلمة المرور</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>

                                        <input type="password" class="form-control" id="exampleFormControlInput3" v-model="data.form.password" placeholder="*******">
                                        <div class="invalid-feedback" :style="getErrors['password'] ? 'display: block' : 'display: none;'"   v-if="getErrors['password']">
                                              {{ getErrors['password'][0] }}
                                         </div>
                                    </div>
                                       </div>
                             
                             
                                                                <div class="col-md-6">
                                                                         
                                      <label for="exampleFormControlSelect1">الصلاحية</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>

                                      
                                        <select class="form-control" id="exampleFormControlSelect1" v-model="data.form.role_id" >
                                            <option v-for="(name, id) in data.roles" :key="id" :value="id">{{name}}</option>
                                        </select>
                                        <div class="invalid-feedback" :style="getErrors['role_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['role_id']">
                                              {{ getErrors['role_id'][0] }}
                                           </div>
                                    </div>
                                       </div>
                                             </div>

                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                      <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'admins'}">
                                      <span>رجوع</span>
                                    </router-link>

                                </form>
                            </div>
                           
                        </div>
                    </div>

                </div>

            </div>

</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    Treeselect,
  },
  data() {
    return {
      data: {
        checker: false,
        form:{
            name: '',
            email: '',
            password: '',
            role_id: '',
        },
        roles: {
        },
        options: [],
        isRequested: false,
        errors: {},
        paginated: {}
      }
    };
  },
  created(){
    this.getRequirements();
  },
  methods: {
      resetForm(){
        this.data.form = {
          name: '',
          email: '',
          password: '',
          role_id: '',
        }
      },
      store(){
          this.data.isRequested = true;
         this.$baseApi.post('/admins', this.data.form).then((response)=>{
            if(response.data.code === 200){
              localStorage.setItem('flash_message', response.data.messages[0]);
              this.sweetAlert(response.data.messages[0])
                router.push('/admins');
            }
        }).catch((error) => {
            this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
            this.data.isRequested = false
          })
      },
      getRequirements(){
        this.getRoles();
      },
      getRoles(){
        this.$baseApi.get('/admins/create').then((response)=>{
            if(response.data.code == 200){
               this.data.roles = response.data.data.roles;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      selected(node, instanceId){
        this.data.form.location_id = node.id;
      },
      getTree(){
        this.$baseApi.get('/locations?tree=true' ).then((response)=>{
            if(response.data.code == 200){
              this.data.options = response.data.data;
            }else if(response.data.code == 401){
                this.error = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    }
  }
};
</script>
<style>
</style>
